import { render } from "./MassHostExternalCommands.vue?vue&type=template&id=55b09b54"
import script from "./MassHostExternalCommands.vue?vue&type=script&lang=js"
export * from "./MassHostExternalCommands.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__